module.exports = __webpack_public_path__ + "static/media/nayra.96675c31.jpg";